export const all_routes = {
  signin: "/signin",
  dashboard: "/dashboard",
  deliveries: "/delivery",
  viewDeliveryReceipt: "/delivery/receipt",
  sales: "/sales",
  createSale: "/create-sale",
  editSale: "/edit-sale",
  viewSaleInvoice: "/sales/invoice",
  viewOriginalSaleInvoice: "/sales/original-invoice",
  purchases: "/purchases",
  createPurchase: "/create-purchase",
  editPurchase: "/edit-purchase",
  products: "/products",
  createProduct: "/create-product",
  editProduct: "/edit-product",
  categories: "/categories",
  createCategory: "/create-category",
  editCategory: "/edit-category",
  brands: "/brands",
  bays: "/bays",
  sizes: "/sizes",
  sections: "/sections",
  paymentHeads: "/payment-heads",
  serviceTypes: "/service-types",
  deliveryTypes: "/delivery-types",
  deliveryTimeSlots: "/delivery-time-slots",
  states: "/states",
  cities: "/cities",
  salePersons: "/sale-persons",
  suppliers: "/suppliers",
  stores: "/stores",
  users: "/users",
  roles: "/roles-permissions",
  permissions: "/permissions",
  stockTransfers: "/stock-transfer",
  addStockTransfer: "/add-stock-transfer",
  editStockTransfer: "/edit-stock-transfer",
  manageStock: "/manage-stock",
  addStock: "/add-stock",
  stockAdjustment: "/stock-adjustment",
  customers: "/customers",
  customerOrders: "/customer-orders",
  refundExchange: "/refund-exchange",
  viewRefundReceipt: "/refund-receipt",
  viewExchangeReceipt: "/exchange-receipt",
  reports: "/reports",
  reportBuilder: "/reports/builder",
  reportViewer: "/reports/viewer",
  dashboard: "/reports/dashboard",
  reportLibrary: "/reports/library",
  systemSettings: "/system-settings",
  proofOfDelivery: "/proof-of-delivery",
};
